var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar-metrics',{staticClass:"rating-metrics my-1",attrs:{"data":_vm.entries,"show-percentages":false}})}
var staticRenderFns = []

export { render, staticRenderFns }